<template>
  <div>
    <div
      class="d-flex"
      style="gap: 11px;"
    >
      <v-tooltip
        v-if="item && item.user"
        top
        color="white"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-avatar
            v-bind="attrs"
            size="30"
            color="error"
            class="v-avatar-light-bg success--text"
            v-on="on"
          >
            <v-img
              v-if="item && item.user.url_photo && item.user.base64"
              :src="item.user.base64"
            />
            <span
              v-else
              class="v-avatar-light-bg success--text"
              style="font-size: 13px;"
            >
              {{ getInitials(item.user) }}
            </span>
          </v-avatar>
        </template>
        <span style="color: black;">
          {{ item && item.user && item.user.name ? item.user.name : '-' }}
        </span>
      </v-tooltip>
      <div
        v-else
        class="d-flex align-center justify-center"
      >
        <span>-</span>
      </div>
      <div
        class="d-flex flex-column"
        style="padding-left: 11px; padding: 2px 0px; gap: 1.5px;"
      >
        <span style="font-size: 15px; font-weight: 500;">{{ item.action }}</span>
        <span style="font-weight: 500; font-size: 13px;">{{ formatIsoDateToNormalDate(item.created_at) }}</span>
      </div>
    </div>
    <div
      v-if="item.cancellation_reason"
      class="d-flex flex-column"
      style="margin-top: 10px; padding-left: 41px; gap: 14px;"
    >
      <span>Motivo:</span>
      <span>{{ item.cancellation_reason || '-' }}</span>
    </div>
  </div>
</template>

<script>
import formatters from '@/plugins/formattersMixin1'
import messages from '@/plugins/showMessageMixin'
import { mdiHeart, mdiPencil, mdiStickerCheckOutline } from '@mdi/js'
import localStorageSlim from 'localstorage-slim'
import { getInitials } from '../helpers/formatHelpers'

export default {
  name: 'TransportTimelineItem',
  mixins: [messages, formatters],
  props: {
    item: {
      type: Object,
      required: true,
    },
    solicData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoadingGetFile: false,
      isViewingFile: false,
      isLoadingFile: false,
      LoggedUserId: '',
      isLoading: false,
      showModalRequesterValidation: false,
      icons: {
        mdiHeart,
        mdiPencil,
        mdiStickerCheckOutline,
      },
    }
  },
  computed: {
    computedViewFileContainer() {
      return !this.isLoadingGetFile
    },
  },
  created() {
    const userProfile = localStorageSlim.get('userProfile', { decrypt: true })
    this.LoggedUserId = userProfile.id
  },
  methods: {
    getInitials,
    formatPrevisionDate(date) {
      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    },
  },
}
</script>
